<template>
    <div>
        <topnav @tosearch="tosearch" :keywords="keyword" :toptype="toptype" types="3" :isSearch="path"></topnav>
        <div class="">
            <div class="" v-if="config">
                <el-image class="topimg" :src="config.pxfu_pic | addurl" fit="fill"></el-image>
            </div>
            <div class="marginauto conwidth topall" >
                <div class="flex justify-start align-center">
                    <div class="" style="color: #959595;font-size: 16px;margin-right: 15px;line-height: 37px;width: 100px;">培训类型：</div>
                    <div class="flex justify-start align-center flex-wrap">
                        <div class="topone pointer" v-for="(item,index) in sortlist" :key="index" @click="tabchange(item.id,index)" :class="item.checked ? 'active':''">{{item.name}}</div>
                    </div>
                </div>
            </div>
            <div class="response bggray" v-if="list.length">
                <div class="conwidth marginauto" style="min-height: 400px;padding-top: 45px;">
                    <div class=" flex justify-between align-center flex-wrap">
                        <div v-for="(item,index) in list" :key="index" @click="todetail(item.id)" class="animated slideInRight">
                            <div class="bg-white flex justify-center align-center pointer hvr-float" style="padding: 20px 20px 20px 15px;width: 615px;border-radius: 5px;margin-bottom: 30px;">
                                <el-image style="width: 220px;height: 220px;display: block;" :src="item.image | addurl" fit="cover"></el-image>
                                <div class="flex-sub" style="padding: 0 20px;height: 220px;">
                                    <div class="text-cut2" style="color: #1c1c1c;font-size: 20px;line-height: 32px;height: 64px;margin-top: 10px;margin-bottom: 25px;">
                                        {{item.name}}
                                    </div>
                                    <div style="color: #909090;font-size: 17px;margin-bottom: 10px;">活动时间：{{item.active_time}}</div>
                                    <div style="color: #909090;font-size: 17px;">活动地点：{{item.address}}</div>
                                    <div class="dbtn">了解详情→</div>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                    <div class="text-center res" style="padding-bottom: 40px;">
                        <el-pagination
                            background
                            layout="prev, pager, next"
                            :pager-count="pagerCount"
                            :hide-on-single-page="true"
                            :page-size="pagesize"
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :total="totalnum"
                            >
                            </el-pagination>
                    </div>
                </div>
            </div>
            <div class="" v-if="!list.length && !load">
                <el-empty description="暂无数据"></el-empty>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return{
            toptype: 5,
            pagesize: 10,
            totalnum: 100,
            currentPage: 1,
            pagerCount: 7,
            sortlist: [],
            tabid: 0,
            load: true,
            config: '',
            list: [],
            path: '/train',
            keyword: ''
        }
    },
    methods:{
        todetail(id){
            this.$router.push({path: '/traindetail',query:{id:id}})
        },
        tabchange(id,index){
            for(let i in this.sortlist){
                this.sortlist[i].checked = false;
            }
            this.sortlist[index].checked = true;
            this.keyword = '';
            this.tabid = id;
            this.getnewlist();
            this.$forceUpdate();
        },
        handleSizeChange(){

        },
        handleCurrentChange(currentPage){
            this.currentPage = currentPage;
            this.list = [];
            this.getlist();
        },
        getnewlist(){
            this.list = [];
            this.currentPage = 1;
            this.totalnum = 0;
            this.getlist();
        },
        getsort(){
            this.$api.index.train_category().then(res => {
                var sdata = {
                    id: 0,
                    name: '全部'
                }
                res.data.unshift(sdata);
                for(let i in res.data){
                    res.data[i]['checked'] = false;
                }
                res.data[0]['checked'] = true;
                this.sortlist = res.data;
            })
        },
        getlist(){
            var sdata = {
                start: this.currentPage,
                page_size: this.pagesize,
                cat_id: this.tabid,
                keyword: this.keyword
            }
            this.$api.index.train_list(sdata).then(res => {
                this.list = res.data;
                this.totalnum = res.count;
                this.load = false;
            })
        },
        tosearch(data){
            console.log(data)
            var data = JSON.parse(data);
            this.keyword = data.keyword;
            this.tabid = '';
            this.list = [];
            this.currentPage = 1;
            this.totalnum = 0;
            this.getlist();
        },
    },
    created(){
        this.getsort();
        if(this.$route.query.keyword){
            this.keyword = this.$route.query.keyword;
            this.list = [];
            this.load = true;
            this.currentPage = 1;
            this.totalnum = 0;
            this.getlist()
        }else{
            this.getlist();
        }
        this.config = JSON.parse(localStorage.getItem('config'))
    }
}
</script>
<style scoped>
    .bggray{
        background-color: #eef1fa;
    }
    .topall{
        padding: 45px 0;
        background-color: #fff;
    }
    .topone{
        padding: 8px 18px;font-size: 16px;color: #4e4e4e;
    }
    .active{
        background-color: #ebf8ff;
	    border-radius: 4px;color: #1759d8;
    }
    .dbtn{
        width: 130px;
        height: 35px;text-align: center;
        line-height: 35px;color: #292929;font-size: 16px;
        background-color: #ffffff;
        border: solid 1px #292929;
        margin-top: 30px;
    }
    .topimg{
        width: 100%;
        /* height: auto; */
        height: 500px;
    }
</style>


// WEBPACK FOOTER //
// train.vue?18e53e0e